export const blockIconsSearchCameraIndoor = (
	<span className='material-symbols-outlined'>camera_indoor</span>
);
